import CONST from '@/constants/gpao/etape';
export default {
  methods: {
    getStatutEtape(value) {
      let statut = '';
      switch (value) {
        case CONST.ATTENTE:
          statut = 'En attente';
          break;
        case CONST.ENCOURS:
          statut = 'En cours';
          break;
        case CONST.ARRETER:
          statut = 'Arrêté';
          break;
        case CONST.TERMINER:
          statut = 'Terminé';
          break;
      }
      return statut;
    },
  },
};
